var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import styled, { keyframes, useTheme } from 'styled-components';
import Icon from '../../Styles/Icons/Icon';
import Tooltip from '../../Elements/Tooltip/Tooltip';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { useCronoSkeleton } from '../../Boost/CronoSkeleton';
const slide = keyframes `
0% {background-position: 0% 50%;}
50% {background-position: 100% 50%;}
100% {background-position: 0% 50%;}
`;
const ProgressBarContainerStyle = styled.div `
    position: relative;
    display: flex;
    width: auto;
    border-radius: 10px;
    background: white;
    height: ${props => props.height};
  }
`;
const ProgressBarStyle = styled.div `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 100%;
  width: ${props => props.width + '%'};
  border: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
  margin-right: 0.1%;
  background: ${props => props.step <= props.current
    ? props.isDone
        ? `linear-gradient(90deg, ${props.theme.utils.getColorLight('done')}, ${props.theme.utils.getColor('done')})`
        : `linear-gradient(90deg, ${props.theme.utils.getColorLight(props.color)}, ${props.theme.utils.getColor(props.color)})`
    : 'none'};
  background-size: 200% 200%;
  animation: ${slide} 4s ease infinite;
  transition: width 1s;
  &:first-child {
    border-top-left-radius: ${props => props.theme.borders.borderRadius};
    border-bottom-left-radius: ${props => props.theme.borders.borderRadius};
  };
  &:last-child {
    border-top-right-radius: ${props => props.theme.borders.borderRadius};
    border-bottom-right-radius: ${props => props.theme.borders.borderRadius};
  }
`;
const check = (shadow, transition) => keyframes `
0% {height: 20px;width: 20px;transform: rotate(0deg);bottom: 0px;box-shadow: ${shadow}}
50% {height: 22px;width: 22px;bottom: 3px;box-shadow: ${transition}}
100% {height: 20px;width: 20px;transform: rotate(360deg);bottom: 0px;box-shadow: "0"}
`;
const CheckProgressStyle = styled.div `
  display: ${props => props.showDisplay ? 'flex' : 'none'} ;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 14px;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  padding: 3px;
  border: ${props => props.theme.utils.borderColor(props.theme.utils.getColor('grey'))};
  background-color: white;
  animation: ${props => check(props.theme.boxes.boxShadow, props.theme.boxes.boxShadowTransition)} 1s ease-out forwards;
`;
const ProgressStep = (_a) => {
    var { isLoading = false, skeleton, tooltipText = '', tooltipPosition, height = '10px', color = 'main', checkPosition, totalSteps = 0, current = 0, noMargin = false, excludeMeFromLoadingContext = false } = _a, props = __rest(_a, ["isLoading", "skeleton", "tooltipText", "tooltipPosition", "height", "color", "checkPosition", "totalSteps", "current", "noMargin", "excludeMeFromLoadingContext"]);
    const { loadingContext } = useCronoSkeleton();
    const data = Array.from({ length: totalSteps }, (_, i) => i);
    const theme = useTheme();
    useEffect(() => {
        if (current > totalSteps) {
            console.error("CRONO PROGRESS STEP: Current can't be higher than steps");
        }
    }, [current, totalSteps]);
    return ((loadingContext && excludeMeFromLoadingContext === false) || isLoading
        ? _jsx(Skeleton, Object.assign({ height: "subArticle", width: "100%", margin: "h", direction: "h", repetition: totalSteps || 3 }, skeleton))
        : _jsx(ProgressBarContainerStyle, Object.assign({ height: height, noMargin: noMargin }, props, { children: data.map((step, i) => {
                return (_jsx(ProgressBarStyle, Object.assign({ width: 100 / data.length, color: color, current: current - 1, step: step, isDone: checkPosition ? current >= checkPosition : false }, { children: _jsx(Tooltip, Object.assign({ position: tooltipPosition, color: theme.colors.doneColor, text: tooltipText }, { children: _jsx(CheckProgressStyle, Object.assign({ showDisplay: checkPosition ? checkPosition - 1 === step && checkPosition <= current : false }, { children: _jsx(Icon, { icon: "check", cursor: "normal", style: { margin: '0', padding: '0' }, color: theme.colors.doneColor }) })) })) }), i));
            }) })));
};
export default ProgressStep;
